// extracted by mini-css-extract-plugin
export default {"h1":"styles__h1___8E1Or","h2":"styles__h2___qS3in","newsItemHeader":"styles__newsItemHeader___frRPK","newsItemContent":"styles__newsItemContent___EPK1J"};